import React from "react";
import { withAllContexts } from "../../../AllContextsWrapper";
import PropTypes from 'prop-types';
import { TextField, Autocomplete, MenuItem, Button, Grid, Box, Step, StepLabel, Stepper, Dialog, Slide, AppBar, Toolbar, IconButton, Typography, Backdrop, CircularProgress } from '@mui/material';
import { Close as CloseIcon, Info as InfoIcon } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import { enqueueSnackbar } from 'notistack';
import moment from 'moment';
import PluginRegistry from '../../../plugins';

import { createTheme, ThemeProvider } from '@mui/material/styles';

class ReservationForm extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      activeStep: 0,
      places: [],
      clients: [],
      searchClientStr: "",
      clientEdited: false,
      clientLoading: false,
      clientSelected: false,
      isExistingClient: false,
      client: {
        name: "",
        phone: "",
        email: ""
      }
    };

    if (this.props.currentReservation !== null) {

      let { color, client, fees, payments, ...form } = this.props.currentReservation;
      this.state.form = {
        ...form
      }

    } else {
      const type = this.props.app.state.activeCalendar?.type || 'rafting';
      const plugin = PluginRegistry.get(type);
      const defaults = plugin.defaults || {};

      this.state.form = {
        client: 0,
        status: "ordered",
        language: "sk",
        start_date: this.props.initDate ? this.parseDate(this.props.initDate) : moment(),
        end_date: this.props.initDate ? this.parseDate(this.props.initDate) : moment(),
        start_place: "",
        end_place: "",
        ...defaults // Load plugin specific defaults (e.g. tents_count for camping, kanoe_count for rafting)
      }
    }
  }

  parseDate = (date) => {
    if (!date) return moment();
    if (typeof date === 'string') {
      // Take only the date part YYYY-MM-DD to ignore any timezone shifts
      return moment(date.substring(0, 10));
    }
    return moment(date);
  }

  formatDate = (date) => {
    return moment(date).format('YYYY-MM-DD');
  }

  getPlaces = async () => {

    const calendarId = this.props.app.state.activeCalendar?.id || 1;

    this.props.socketIO.socket.emit('places:getAll', calendarId, (response) => {

      if (response.success) {
        this.setState({
          places: response.data
        })
      } else {
        this.setState({
          places: []
        })
      }
    });
  }

  searchClients = (str) => {
    this.setState({
      searchClientStr: str
    });

    if (str && str.trim().length > 0) {
      this.props.socketIO.socket.emit('client:search', str.trim(), (response) => {
        if (response.success) {
          this.setState({
            clients: response.data
          })
        } else {
          this.setState({
            clients: []
          })
        }
      });
    } else {
      this.setState({
        clients: []
      })
    }
  }

  handleClientChange = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(prevState => ({
      clientEdited: true,
      client: {
        ...prevState.client,
        [name]: value
      }
    }))
  }

  updateFormState = (value, name) => {
    console.log('updateFormState', value, name);
    if (name === 'start_date') {

      /* if (!this.state.form.end_date || this.state.form.end_date.isBefore(value)) {
        console.log('isBefore', value, name);
      } */

      if (!this.state.form.end_date || new Date(this.state.form.end_date).getTime() < new Date(value).getTime()) {
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            end_date: value
          }
        }))
      }
    }
    if (name === 'kanoe_count_info_min') {
      // Auto-sync max to min for convenience (User request)
      this.setState(prevState => ({
        form: {
          ...prevState.form,
          kanoe_count_info_max: value
        }
      }))
    }

    if (name === 'kanoe_count_info_max') {
      const max = parseInt(value) || 0;
      const min = parseInt(this.state.form.kanoe_count_info_min) || 0;

      if (max > 0 && max < min) {
        // If max is less than min, set min to max
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            kanoe_count_info_min: value
          }
        }))
      }
    }
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [name]: value
      }
    }))
  }

  handleClientSubmit = () => {
    let client = this.state.client;
    if (client.email.length === 0 && client.phone.length === 0 && client.name.length === 0) {
      enqueueSnackbar('Treba vyplniť aspoň jedno z polí', { variant: 'error' });
      return;
    }


    let strings = {
      endpoint: 'client:create',
      success: 'Klient úspešne vytvorený',
      error: 'Klienta sa nepodarilo vytvoriť'
    }

    if (this.state.isExistingClient) {
      strings = {
        endpoint: 'client:update',
        success: 'Klient úspešne upravený',
        error: 'Klienta sa nepodarilo upraviť'
      }
    }

    const phoneStr = client.phone || '';
    client = {
      id: client.id ? client.id : "",
      name: client.name && client.name.length > 0 ? client.name : null,
      phone: phoneStr.length > 0 ? phoneStr : null,
      email: client.email && client.email.length > 0 ? client.email : null
    }
    this.setState({
      clientLoading: true
    })

    this.props.socketIO.socket.emit(strings.endpoint, client, (response) => {
      if (response.success) {
        enqueueSnackbar(strings.success, { variant: 'success' });

        let s = {
          client: response.data,
          activeStep: this.state.activeStep + 1,
        }

        if (!this.state.isExistingClient) s.form = { ...this.state.form, client: response.data.id }

        this.setState(s);
      } else {
        enqueueSnackbar(strings.error, { variant: 'error' });
      }

      this.setState({
        clientLoading: false
      })
    });
  }

  updateClientState = (value, name) => {
    this.setState(prevState => ({
      client: {
        ...prevState.client,
        [name]: value
      }
    }))
  }

  handleFormSubmit = () => {

    let strings = {
      endpoint: 'reservations:create',
      success: 'Rezervácia úspešne pridaná',
      error: 'Rezerváciu sa nepodarilo pridať'
    }

    let form = { ...this.state.form };
    form.calendar_id = this.props.app.state.activeCalendar?.id || 1;

    /*     if (form.start_date) {
          let startDate = new Date(form.start_date);
          form.start_date = startDate.toISOString().split('T')[0] + 'T00:00:00.000Z';
        }
    
        if (form.end_date) {
          let endDate = new Date(form.end_date);
          form.end_date = endDate.toISOString().split('T')[0] + 'T00:00:00.000Z';
        } */

    if (!(this.props.currentReservation === null) && this.props.currentReservation.id) {
      strings = {
        endpoint: 'reservations:update',
        success: 'Rezervácia úspešne upravená',
        error: 'Rezerváciu sa nepodarilo upraviť'
      }

      form.client = this.state.client.id; // Use the ID from the potentially updated client state
    }

    // Fix for backend expecting client_id in update
    form.client_id = form.client;

    // Ensure status is never null
    if (!form.status) {
      console.warn('Status was missing, defaulting to ordered');
      form.status = 'ordered';
    }

    this.props.socketIO.socket.emit(strings.endpoint, form, (response) => {
      if (response.success === true) {
        this.props.app.functions.updateMainCalendar();
        // Also refresh the currently open reservation detail if we edited it
        if (response.data && response.data.id) {
          this.props.app.functions.updateCurrReservation(response.data.id);
        } else if (form.id) {
          this.props.app.functions.updateCurrReservation(form.id);
        }
        this.toggleAdding();
        enqueueSnackbar(strings.success, {
          variant: "success",
        });
      } else {
        enqueueSnackbar(strings.error, {
          variant: "error",
        });
      }
    });
  }

  toggleAdding = () => {
    window.history.back();
    this.setState({
      activeStep: 0,
      places: [],
      clients: [],
      searchClientStr: "",
      clientEdited: false,
      clientLoading: false,
      clientSelected: false,
      isExistingClient: false,
      client: {
        name: "",
        phone: "",
        email: ""
      },
      form: {
        client: 0,
        status: "ordered",
        language: "sk",
        start_date: "",
        end_date: "",
        start_place: "",
        end_place: "",
        kanoe_count_info_min: 0,
        kanoe_count_info_max: 0,
        katamaran_count_info: 0,
        kanoe_count: 0,
        katamaran_count: 0,
        vest_count: 0,
        paddle_count: 0,
        barrel_count: 0,
        note: ""
      }
    })
  };

  componentDidMount() {
    this.getPlaces();
    this.handlePrefill();
  }

  handlePrefill = () => {
    if (this.props.prefillClientId) {
      this.setState({ clientLoading: true });
      this.props.socketIO.socket.emit('client:getById', parseInt(this.props.prefillClientId), (response) => {
        this.setState({ clientLoading: false });
        if (response.success) {
          this.setState(prevState => ({
            client: response.data,
            isExistingClient: true,
            clientSelected: true,
            activeStep: 1, // Go to Step 2 (Client Data)
            form: { 
              ...prevState.form, 
              client: response.data.id,
              start_date: prevState.form.start_date || this.parseDate(moment()),
              end_date: prevState.form.end_date || this.parseDate(moment()),
            }
          }));
        }
        if (this.props.onPrefillDone) this.props.onPrefillDone();
      });
    } else if (this.props.prefillPhone) {
      this.setState(prevState => ({
        client: { name: "", phone: this.props.prefillPhone, email: "" },
        isExistingClient: false,
        clientSelected: true,
        activeStep: 1, // Go to Step 2 (Client Data) to fill name
        form: {
          ...prevState.form,
          client: 0,
          start_date: prevState.form.start_date || moment(),
          end_date: prevState.form.end_date || moment(),
        }
      }));
      if (this.props.onPrefillDone) this.props.onPrefillDone();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { currentReservation, initDate, prefillClientId, prefillPhone } = this.props;

    if (prefillClientId !== prevProps.prefillClientId || prefillPhone !== prevProps.prefillPhone) {
      this.handlePrefill();
    }



    if (prevProps.currentReservation !== currentReservation && typeof currentReservation == "object" && currentReservation !== null) {
      this.setState({
        activeStep: 2,
        client: this.props.currentReservation.client || { name: "", phone: "", email: "" },
        form: {
          ...this.props.currentReservation,
          status: this.props.currentReservation.status || 'ordered',
          client: this.props.currentReservation.client !== undefined ? this.props.currentReservation.client.id : 0,
          start_date: this.props.currentReservation.start_date !== null ? this.parseDate(this.props.currentReservation.start_date) : moment(),
          end_date: this.props.currentReservation.end_date !== null ? this.parseDate(this.props.currentReservation.end_date) : moment(),
        }
      })
    }

    if (prevProps.currentReservation !== null && currentReservation === null) {
      const type = this.props.app.state.activeCalendar?.type || 'rafting';
      const plugin = PluginRegistry.get(type);
      const defaults = plugin.defaults || {};

      this.setState({
        activeStep: 0,
        form: {
          client: 0,
          status: "ordered",
          language: "sk",
          start_date: this.props.initDate !== null ? this.parseDate(this.props.initDate) : moment(),
          end_date: this.props.initDate !== null ? this.parseDate(this.props.initDate) : moment(),
          start_place: "",
          end_place: "",
          ...defaults
        }
      })
    }

    if (prevProps.initDate !== initDate && !this.props.prefillClientId && !this.props.prefillPhone) {
      const type = this.props.app.state.activeCalendar?.type || 'rafting';
      const plugin = PluginRegistry.get(type);
      const defaults = plugin.defaults || {};

      let f = {
        client: 0,
        status: "ordered",
        start_place: "",
        end_place: "",
        ...defaults,
        start_date: this.props.initDate !== null ? moment.utc(this.props.initDate).local() : moment(),
        end_date: this.props.initDate !== null ? moment.utc(this.props.initDate).local() : moment(),
      }

      this.setState({
        activeStep: 0,
        clients: [],
        searchClientStr: "",
        clientEdited: false,
        clientLoading: false,
        clientSelected: false,
        isExistingClient: false,
        client: {
          name: "",
          phone: "",
          email: ""
        },
        form: {
          ...f
        }
      })
    }
  }

  handleBack = () => {
    if (this.state.activeStep === 0) window.history.back();
    if (this.state.activeStep === 2 && this.props.currentReservation !== null) window.history.back();

    this.setState({
      activeStep: this.state.activeStep - 1,
    });
  };

  handleNext = () => {
    if (this.state.activeStep === 1 && (this.state.clientEdited || !this.state.isExistingClient)) {
      this.handleClientSubmit();
    } else if (this.state.activeStep === 2) {
      this.handleFormSubmit();
    } else {
      this.setState({
        activeStep: this.state.activeStep + 1,
      });
    }
  };

  // ... imports remain the same

  calculatePrice = () => {
    const { start_date, end_date } = this.state.form;
    const { activeCalendar } = this.props.app.state;

    if (!start_date || !end_date) return null;
    if (!activeCalendar) return null;

    const start = moment(start_date);
    const end = moment(end_date);
    const reservationLength = end.diff(start, 'days') + 1;

    if (reservationLength <= 0) return null;

    const plugin = PluginRegistry.get(activeCalendar.type || 'rafting');
    
    if (plugin && plugin.calculatePrice) {
      const price = plugin.calculatePrice(this.state.form, reservationLength, this.props.app);
      return { type: 'finished', price: price };
    }

    return null;
  }

  render() {
    let title = this.props.currentReservation === null ? "Nová rezervácia" : "Úprava rezervácie #" + this.props.currentReservation.id;
    const plugin = PluginRegistry.get(this.props.app.state.activeCalendar?.type || 'rafting');
    const PluginFormFields = plugin.FormFields;
    const calculatedPrice = this.calculatePrice();

    const isCamping = this.props.app.state.activeCalendar?.type === 'accommodation';
    const primaryColorHex = isCamping ? '#1A3C34' : '#0D5D56'; // Pine or Teal
    const secondaryColorHex = isCamping ? '#E85D04' : '#FF7F3E'; // Ember or Orange

    const dynamicTheme = createTheme({
      palette: {
        primary: {
          main: primaryColorHex,
        },
        secondary: {
          main: secondaryColorHex,
        },
      },
      components: {
        MuiTextField: {
          styleOverrides: {
            root: {
              '& .MuiOutlinedInput-root': {
                borderRadius: '0.75rem',
              }
            }
          }
        }
      }
    });

    const progressBarBgClass = isCamping ? "bg-taborisko-orange" : "bg-splavma-teal";

    let clientsArray = [];
    if (this.state.clients.length > 0) {
      clientsArray = this.state.clients.map((client) => {
        let label = "";
        if (client.name !== null) label += client.name;
        if (client.phone !== null) label += ", " + client.phone;
        if (client.email !== null) label += ", " + client.email;
        return { label: label, id: client.id, client: client }
      });
    }

    let placesArray = [];
    if (this.state.places.length > 0) {
      placesArray = this.state.places.map((place) => ({
        label: place.name, id: place.id, price: place.price
      }));
    }

    const inputClass = "w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 transition-all outline-none text-sm font-medium disabled:bg-gray-50 disabled:text-gray-400";
    const labelClass = "block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1.5 ml-1";
    const muiInputSx = {
      '& .MuiOutlinedInput-root': {
        borderRadius: '0.75rem',
        backgroundColor: 'white',
        '& fieldset': { borderColor: '#e5e7eb' },
        '&:hover fieldset': { borderColor: '#d1d5db' },
        '&.Mui-focused fieldset': { borderColor: primaryColorHex, borderWidth: '1px' },
      },
      '& .MuiInputBase-input': { fontSize: '0.875rem', fontWeight: 500 }
    };

    const steps = ['Vyhľadanie klienta', 'Údaje klienta', 'Vytvorenie rezervácie'];

    let nextButtonText = 'Ďalej';
    if (this.state.activeStep === 1 && this.state.isExistingClient && this.state.clientEdited) nextButtonText = 'Aktualizovať klienta';
    if (this.state.activeStep === 1 && !this.state.isExistingClient) nextButtonText = 'Vytvoriť klienta';
    if (this.state.activeStep === steps.length - 1) nextButtonText = 'Vytvoriť rezerváciu';
    if (this.state.activeStep === 2 && this.props.currentReservation !== null) nextButtonText = 'Aktualizovať rezerváciu';

    return (
      <ThemeProvider theme={dynamicTheme}>
        <Dialog
          fullScreen
          open={this.props.isOpen}
          TransitionComponent={Transition}
          PaperProps={{
            className: isCamping ? "bg-taborisko-beige" : "bg-gray-50"
          }}
        >
          {/* Modern Sticky Header */}
          <div className={`fixed top-0 left-0 right-0 z-50 border-b ${isCamping ? 'bg-taborisko-beige border-taborisko-pine/10' : 'bg-white border-gray-200'}`}>
            <div className="flex items-center justify-between px-4 h-16">
              <button
                onClick={() => this.toggleAdding()}
                className={`p-2 -ml-2 rounded-full transition-colors ${isCamping ? 'text-taborisko-pine hover:bg-taborisko-pine/5' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'}`}
              >
                <CloseIcon />
              </button>
              <div className="flex-1 ml-4">
                <h2 className={`text-lg font-bold leading-tight ${isCamping ? 'text-taborisko-pine' : 'text-gray-900'}`}>{title}</h2>
                {!this.props.app.state.isCurrentlyEditing && (
                  <div className={`text-xs font-medium uppercase tracking-wider ${isCamping ? 'text-taborisko-pine/60' : 'text-gray-500'}`}>
                    Krok {this.state.activeStep + 1} z {steps.length}: {steps[this.state.activeStep]}
                  </div>
                )}
              </div>
            </div>
            {/* Progress Bar */}
            {!this.props.app.state.isCurrentlyEditing && (
              <div className={`h-1 w-full ${isCamping ? 'bg-taborisko-pine/10' : 'bg-gray-100'}`}>
                <div
                  className={`h-full transition-all duration-300 ease-in-out ${progressBarBgClass}`}
                  style={{ width: `${((this.state.activeStep + 1) / steps.length) * 100}%` }}
                />
              </div>
            )}
          </div>

          {/* Scrollable Content */}
          <div className="flex-1 pt-20 pb-24 overflow-y-auto overflow-x-hidden">
            <div className="max-w-md mx-auto px-4 sm:px-6">

              {this.state.activeStep === steps.length ? (
                <div className="flex flex-col items-center justify-center pt-24 space-y-4">
                  <CircularProgress className={isCamping ? "text-taborisko-orange" : "text-splavma-teal"} size={48} />
                  <p className={`font-medium uppercase tracking-wider text-sm ${isCamping ? 'text-taborisko-pine/60' : 'text-gray-500'}`}>Spracovávam...</p>
                </div>
              ) : (
                <div className="space-y-6">

                  {/* Step 0: Search Client */}
                  {this.state.activeStep === 0 && (
                    <div className="space-y-4">
                      <div className={`p-5 shadow-sm border ${isCamping ? 'bg-white border-taborisko-pine/10' : 'bg-white border-gray-100'}`}>
                        <label className={labelClass}>Vyhľadajte klienta</label>
                        <input
                          type="search"
                          autoComplete="off"
                          className={inputClass}
                          placeholder="Meno, email alebo telefón"
                          value={this.state.searchClientStr}
                          onChange={(e) => this.searchClients(e.target.value)}
                        />
                      </div>

                      {/* Inline results — scrollable list with safe height for mobile keyboards */}
                      <div
                        className={`shadow-sm border divide-y divide-gray-100 max-h-[35vh] sm:max-h-[50vh] overflow-y-auto mb-20 ${isCamping ? 'bg-white border-taborisko-pine/10' : 'bg-white border-gray-100'}`}
                        onTouchStart={() => { this._isDragging = false; }}
                        onTouchMove={() => { this._isDragging = true; }}
                      >
                        {/* Always-visible New Client button */}
                        <button
                          className="w-full text-left px-5 py-4 flex items-center gap-3 hover:bg-gray-50 active:bg-gray-100 transition-colors"
                          onClick={(e) => {
                            if (this._isDragging) return;
                            this.setState({ clientSelected: true, activeStep: 1, isExistingClient: false, client: { name: "", phone: "", email: "" } });
                          }}
                        >
                          <span className={`text-xl font-light ${isCamping ? 'text-taborisko-orange' : 'text-splavma-teal'}`}>+</span>
                          <span className="font-semibold text-sm text-gray-800">Nový klient</span>
                        </button>

                        {/* Search results sorted by best match */}
                        {(() => {
                          const q = this.state.searchClientStr.toLowerCase().trim();
                          const cleanQ = q.replace(/\s+/g, '');
                          
                          const sorted = [...clientsArray].sort((a, b) => {
                            if (!q) return 0;
                            
                            const getScore = (item) => {
                              let score = 0;
                              const name = (item.client?.name || '').toLowerCase();
                              const phone = (item.client?.phone || '').toLowerCase();
                              const email = (item.client?.email || '').toLowerCase();
                              const cleanPhone = phone.replace(/\s+/g, '');
                              
                              // Exact matches
                              if (name === q || email === q || cleanPhone === cleanQ) score += 100;
                              
                              // Starts with matches
                              if (name.startsWith(q)) score += 50;
                              if (email.startsWith(q)) score += 50;
                              
                              // Phone matching (since backend returns partial matches, we prioritize those where our query is inside the phone)
                              if (cleanPhone.includes(cleanQ) && cleanQ.length > 2) score += 60;
                              
                              // Contains matches
                              if (name.includes(q)) score += 10;
                              if (email.includes(q)) score += 10;
                              
                              return score;
                            };
                            
                            return getScore(b) - getScore(a); // Sort descending by score
                          });
                          
                          return sorted.map((item) => (
                            <button
                              key={item.id}
                              className="w-full text-left px-5 py-4 flex flex-col hover:bg-gray-50 active:bg-gray-100 transition-colors"
                              onClick={(e) => {
                                if (this._isDragging) return;
                                this.setState({
                                  clientSelected: true, activeStep: 1, isExistingClient: true,
                                  client: { ...item.client }, form: { ...this.state.form, client: item.id }
                                });
                              }}
                            >
                              <span className="font-semibold text-sm text-gray-900">{item.client?.name || '—'}</span>
                              <span className="text-xs text-gray-400 mt-0.5">{[item.client?.phone, item.client?.email].filter(Boolean).join(' · ')}</span>
                            </button>
                          ));
                        })()}

                        {this.state.searchClientStr && clientsArray.length === 0 && (
                          <div className="px-5 py-4 text-sm text-gray-400 italic">Žiadni klienti nenájdení</div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Step 1: Client Data */}
                  {this.state.activeStep === 1 && (
                    <div className="space-y-4">
                      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={this.state.clientLoading}>
                        <CircularProgress color="inherit" />
                      </Backdrop>

                      <div className={`p-5 shadow-sm border space-y-5 ${isCamping ? 'bg-white border-taborisko-pine/10' : 'bg-white border-gray-100'}`}>
                        <h3 className={`text-[10px] font-black uppercase tracking-widest mb-2 ${isCamping ? 'text-taborisko-orange' : 'text-splavma-teal'}`}>Osobné údaje klienta</h3>
                        <div>
                          <label className={labelClass}>Meno a priezvisko</label>
                          <input
                            type="text"
                            name="name"
                            className={inputClass}
                            value={this.state.client.name}
                            onChange={this.handleClientChange}
                            placeholder="Janko Hraško"
                          />
                        </div>
                        <div>
                          <label className={labelClass}>Telefón</label>
                          <input
                            type="tel"
                            name="phone"
                            className={inputClass}
                            value={this.state.client.phone}
                            onChange={this.handleClientChange}
                            placeholder="+421 9xx xxx xxx"
                          />
                        </div>
                        <div>
                          <label className={labelClass}>Email</label>
                          <input
                            type="email"
                            name="email"
                            className={inputClass}
                            value={this.state.client.email}
                            onChange={this.handleClientChange}
                            placeholder="meno@domena.sk"
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Step 2: Reservation Data */}
                  {this.state.activeStep === 2 && (
                    <div className="space-y-6">
                      {/* Status & Dates Block */}
                      <div className={`p-5 shadow-sm border space-y-5 ${isCamping ? 'bg-white border-taborisko-pine/10' : 'bg-white border-gray-100'}`}>
                        <h3 className={`text-[10px] font-black uppercase tracking-widest ${isCamping ? 'text-taborisko-orange' : 'text-splavma-teal'}`}>Základné údaje</h3>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                          <div>
                            <label className={labelClass}>Stav rezervácie</label>
                            <select
                              name="status"
                              className={inputClass}
                              value={this.state.form.status}
                              onChange={(e) => this.updateFormState(e.target.value, e.target.name)}
                            >
                              {this.props.app.functions.getReservationStatusStrings().map((status) => (
                                <option value={status.value} key={status.value}>{status.label}</option>
                              ))}
                            </select>
                          </div>

                          <div>
                            <label className={labelClass}>Jazyk komunikácie</label>
                            <select
                              name="language"
                              className={inputClass}
                              value={this.state.form.language || "sk"}
                              onChange={(e) => this.updateFormState(e.target.value, e.target.name)}
                            >
                              <option value="sk">Slovenský</option>
                              <option value="en">Anglický</option>
                            </select>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label className={labelClass}>Od</label>
                            <DatePicker
                              value={this.state.form.start_date}
                              onChange={(value) => this.updateFormState(value, 'start_date')}
                              slotProps={{ 
                                textField: { 
                                  fullWidth: true, 
                                  variant: "outlined",
                                  sx: muiInputSx
                                } 
                              }}
                            />
                          </div>
                          <div>
                            <label className={labelClass}>Do</label>
                            <DatePicker
                              value={this.state.form.end_date}
                              minDate={this.state.form.start_date}
                              onChange={(value) => this.updateFormState(value, 'end_date')}
                              slotProps={{ 
                                textField: { 
                                  fullWidth: true, 
                                  variant: "outlined",
                                  sx: muiInputSx
                                } 
                              }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Plugin Fields (Equipment etc) */}
                      <div className={`p-5 shadow-sm border ${isCamping ? 'bg-white border-taborisko-pine/10' : 'bg-white border-gray-100'}`}>
                        <h3 className={`text-[10px] font-black uppercase tracking-widest mb-5 ${isCamping ? 'text-taborisko-orange' : 'text-splavma-teal'}`}>Detaily a parametre</h3>
                        <Grid container spacing={3}>
                          <PluginFormFields
                            form={this.state.form}
                            updateFormState={this.updateFormState}
                            placesArray={placesArray}
                            inputClass={inputClass}
                            labelClass={labelClass}
                            muiInputSx={muiInputSx}
                          />
                        </Grid>
                      </div>

                      {/* Note */}
                      <div className={`p-5 shadow-sm border ${isCamping ? 'bg-white border-taborisko-pine/10' : 'bg-white border-gray-100'}`}>
                        <label className={labelClass}>Poznámka</label>
                        <textarea
                          placeholder="Sem napíšte poznámku..."
                          name="note"
                          rows={3}
                          className={`${inputClass} resize-none`}
                          value={this.state.form.note}
                          onChange={(e) => this.updateFormState(e.target.value, e.target.name)}
                        />
                      </div>

                      {/* Price Summary */}
                      {(() => {
                        const calcResult = calculatedPrice;
                        let priceLabel = isCamping ? "Odhadovaná cena za pobyt" : "Cena za prenájom lodí";
                        let priceValue = <span className={`text-lg font-medium ${isCamping ? 'text-taborisko-pine/60' : 'text-blue-400'}`}>-- €</span>;

                        if (calcResult) {
                          if (calcResult.type === 'finished') {
                            priceLabel = isCamping ? "Celková cena za pobyt" : "Finálna cena za lode";
                            priceValue = <span className={`text-2xl font-bold ${isCamping ? 'text-taborisko-pine' : 'text-blue-700'}`}>{calcResult.price} €</span>;
                          } else if (calcResult.type === 'preliminary') {
                            priceLabel = isCamping ? "Predbežná cena za pobyt" : "Predbežná cena (z min/max)";
                            if (calcResult.minPrice === calcResult.maxPrice && calcResult.minPrice > 0) {
                              priceValue = <span className={`text-xl font-bold ${isCamping ? 'text-taborisko-orange' : 'text-orange-600'}`}>~ {calcResult.minPrice} €</span>;
                            } else if (calcResult.minPrice > 0 || calcResult.maxPrice > 0) {
                              priceValue = <span className={`text-xl font-bold ${isCamping ? 'text-taborisko-orange' : 'text-orange-600'}`}>{calcResult.minPrice} - {calcResult.maxPrice} €</span>;
                            }
                          }
                        }

                        if (!calcResult && isCamping) return null; // Camping handles prices differently

                        return (
                          <div className={`p-5 shadow-sm border flex items-center justify-between ${calcResult?.type === 'finished' ? (isCamping ? 'bg-taborisko-pine/5 border-taborisko-pine/20' : 'bg-blue-50 border-blue-100') : (isCamping ? 'bg-taborisko-orange/5 border-taborisko-orange/20' : 'bg-orange-50 border-orange-100')}`}>
                            <div>
                              <div className={`text-sm font-bold uppercase tracking-wide mb-1 ${calcResult?.type === 'finished' ? (isCamping ? 'text-taborisko-pine' : 'text-blue-900') : (isCamping ? 'text-taborisko-orange' : 'text-orange-900')}`}>
                                {calcResult?.type === 'preliminary' ? 'Odhadovaná cena' : 'Celková cena'}
                              </div>
                              <div className={`text-xs ${calcResult?.type === 'finished' ? (isCamping ? 'text-taborisko-pine/70' : 'text-blue-700') : (isCamping ? 'text-taborisko-orange/80' : 'text-orange-700')}`}>
                                {priceLabel}
                              </div>
                            </div>
                            <div className="text-right">
                              {priceValue}
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Sticky Footer */}
          <div className={`fixed bottom-0 left-0 right-0 p-4 border-t z-50 ${isCamping ? 'bg-taborisko-beige border-taborisko-pine/10' : 'bg-white border-gray-200'}`}>
            <div className="max-w-md mx-auto flex gap-3">
              <Button
                disabled={this.state.activeStep === 0 || (this.state.activeStep === 2 && this.props.currentReservation == null)}
                onClick={this.handleBack}
                className="flex-1"
                variant="outlined"
                size="large"
                sx={{ borderRadius: '9999px', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.05em', height: '56px' }}
              >
                Späť
              </Button>

              <Button
                onClick={this.handleNext}
                className="flex-1"
                variant="contained"
                size="large"
                sx={{ borderRadius: '9999px', textTransform: 'uppercase', fontWeight: 700, letterSpacing: '0.05em', height: '56px', boxShadow: 'none' }}
                disableElevation
              >
                {nextButtonText}
              </Button>
            </div>
          </div>
        </Dialog>
      </ThemeProvider>
    );
  }
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

ReservationForm.propTypes = {
  currentReservation: PropTypes.object,
  initDate: PropTypes.instanceOf(Date),
};

ReservationForm.defaultProps = {
  currentReservation: null,
  initDate: null,
};

export default withAllContexts(ReservationForm);
